import { FC } from 'react'

import {
  Text,
  GreyGrey80,
  Primary13Regular,
  SimpleModal,
  Flex
} from '@sequencehq/core-components'
import { ModalWithEsignatureProps } from './types'
import { RecipientsSection } from '../RecipientsSection'
import {
  PUBLISH_BUTTON_COPY,
  publishSubmitButtonText,
  publishSubmitData
} from '../publishSubmit'
import {
  MODAL_BASE_PROPS,
  PUBLISH_MODAL_COPY
} from '../PublishQuoteModalV2.constants'
import { ApprovalFields } from '../ApprovalFields'

export const ModalRepublishAfterExpiredReadyToSignWithChanges: FC<
  ModalWithEsignatureProps
> = ({
  onSubmit,
  isApprovalRequired,
  message,
  setMessage,
  approvalComment,
  setApprovalComment,
  recipients,
  ...props
}) => {
  return (
    <SimpleModal
      {...MODAL_BASE_PROPS}
      {...props}
      data-testid="modal.publishQuote.republishAfterExpiredReadyToSignWithChanges"
      title={
        isApprovalRequired
          ? PUBLISH_MODAL_COPY.approvalRequired.title
          : PUBLISH_MODAL_COPY.republishQuote.title
      }
      onSubmit={async () => {
        await onSubmit(
          publishSubmitData({
            recipients,
            message,
            approvalComment,
            isApprovalRequired
          })
        )

        return true
      }}
      submitButtonText={publishSubmitButtonText({
        isApprovalRequired,
        recipients,
        copy: PUBLISH_BUTTON_COPY.republish
      })}
      submittingButtonText={
        isApprovalRequired
          ? PUBLISH_MODAL_COPY.approvalRequired.submittingButton
          : PUBLISH_MODAL_COPY.publishQuote.submittingButton
      }
    >
      <Flex gap="16px" flexDir="column">
        <Text {...Primary13Regular} color={GreyGrey80}>
          {isApprovalRequired
            ? PUBLISH_MODAL_COPY.approvalRequired.body
            : `You're about to republish this quote. Selected recipients will receive a notification. Selected signers will be asked to sign again, even if they have previously signed.`}
        </Text>

        {isApprovalRequired && (
          <ApprovalFields
            data-testid="modal.publishQuote.approvalComment"
            approvalComment={approvalComment}
            setApprovalComment={value => setApprovalComment(value)}
          />
        )}

        <RecipientsSection
          recipients={recipients}
          message={message}
          setMessage={setMessage}
          submitting={props.submitting}
        />
      </Flex>
    </SimpleModal>
  )
}
